import React from "react";
import CrudPage from "./CrudPage";

const KINDS = [
  "industries", "market_segments", "competitors", "products", "services",
  "customer_profiles", "geographic_markets", "languages",
  "business_opportunities", "market_trends",
];

export default function MarketResearch() {
  return (
    <CrudPage
      title="Market Research"
      subtitle="Sole owner of market intelligence (SEO Studio §4)."
      testIdPrefix="market"
      listUrl="/seo/market/entries?limit=200"
      createUrl="/seo/market/entries"
      updateUrl={(id) => `/seo/market/entries/${id}`}
      deactivateUrl={(id, r) => `/seo/market/entries/${id}/deactivate?change_reason=${encodeURIComponent(r)}`}
      columns={[
        { key: "kind", label: "Kind" },
        { key: "name", label: "Name" },
        { key: "notes", label: "Notes" },
      ]}
      fields={[
        { key: "kind", label: "Kind", type: "select", options: KINDS },
        { key: "name", label: "Name", type: "text" },
        { key: "notes", label: "Notes", type: "textarea", rows: 3 },
        { key: "payload_json", label: "Payload (JSON)", type: "textarea", rows: 4,
          placeholder: '{"country": "SG"}' },
      ]}
      emptyForm={{ kind: "competitors", name: "", notes: "", payload_json: "{}" }}
      fromRow={(row) => ({
        kind: row.data.kind, name: row.data.name, notes: row.data.notes || "",
        payload_json: JSON.stringify(row.data.payload || {}, null, 2),
      })}
      canonicalizeCreate={(f) => ({
        kind: f.kind, name: f.name, notes: f.notes || null,
        payload: safeJSON(f.payload_json),
      })}
      canonicalizeUpdate={(f) => ({
        name: f.name, notes: f.notes || null,
        payload: safeJSON(f.payload_json),
        change_reason: "edited via admin UI",
      })}
    />
  );
}

function safeJSON(s) {
  try { return JSON.parse(s || "{}"); } catch { return {}; }
}
